export const projects = [
    {
        title: 'Zust Dashboard',
        github: '',
        url: 'https://zustapp.com/',
        description: 'It is a E-commerece Dashboard for product, user, orders, revenue and employee management.',
        image: `${process.env.PUBLIC_URL}/project/zust-dashboard.png`
    }
,
    {
        title: 'PORTFOLIO BUILDER',
        github: 'https://github.com/mjmaurya/resume-website-builder',
        url: 'https://codescripts.azurewebsites.net/ResumeBuilder',
        description: 'ONLINE PORTFOLIO BUILDER is a online tool. Here you can create your own Portfolio within 5 mitnus without any coding.',
        image: `${process.env.PUBLIC_URL}/project/op-builder.png`
    },
    {
        title: 'MJBUTTON',
        github: 'github',
        url: 'https://mjmaurya.github.io/MJButtons/index.html',
        description: 'BJBUTTON is a CSS library for different stylish buttons. You can use this library through library CDN or download minified css.',
        image: `${process.env.PUBLIC_URL}/project/mj-button.png`
    },
    {
        title: 'YourArticle',
        github: 'https://github.com/mjmaurya/myBlog',
        description: 'YourArticle is a blog website created using React,NodeJs and MongoDB. You can find here well written web technology articles',
        image: `${process.env.PUBLIC_URL}/project/your-article.avif`
    }
]